<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="5">
          <div>
            <h3 class="title mb-3">Capture Feed</h3>
            <!-- <v-divider></v-divider> -->
          </div>
          <!-- {{ currentEventDetails }}
          {{ detectionObjects }} -->
          <div class="d-flex align-center">
            <v-btn-toggle v-model="toggle_one" mandatory>
              <v-btn>
                RGB
              </v-btn>
              <v-btn>
                THERMAL
              </v-btn>
              <v-btn @click="playAlertSound">
                IR
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <div>
              <v-icon color="primary" small left>mdi-record-circle</v-icon>
              <span class="body-1">Recording</span>
            </div>
          </div>
          <v-card color="grey">
            <v-img @load="test" @error="retest" height="450" width="100%" cover :src="streamUrl">
              <!-- <v-img height="480" width="100%" cover src="./../assets/annotated_fence_large.png"> -->
              <!-- :src="require('./../assets/'+images[toggle_one])" -->
              <div class="ma-3">
                <v-icon small color="green">
                  mdi-circle
                </v-icon> <strong class="overline">
                  LIVE (MAIN CAM)
                </strong>
              </div>
            </v-img>
          </v-card>

          <v-alert width="400" class="font-weight-bold" style="margin-top: 160px;" type="error" dismissible
            transition="fade-transition" v-model="waitForCaptioning">
            <!-- Alert! Intrusion detected -->
            Alert! New Detection
          </v-alert>

        </v-col>

        <v-col cols="7">
          <div class="mx-3">
            <h3 class="title">Logs</h3>
            <!-- <v-divider></v-divider> -->
          </div>
          <div>
            <v-row no-gutters>
              <v-col md="12">
                <v-row no-gutters>
                  <v-col md="12">
                    <v-card class="ma-3 pb-5 pt-4" outlined>
                      <v-card-text>
                        <h4 class="title d-flex align-center justify-center mb-4 primary--text pb-4">
                          <v-icon color="primary" left>mdi-cube-scan</v-icon>
                          <span>Realtime Scan</span>
                        </h4>
                        <v-row no-gutters>
                          <v-col cols="2">
                            <h6 class="overline">Num Objects</h6>
                            <div class="display-1 font-weight-bold d-inline white--text">
                              {{ detectionSnap['Number-Of-People'] + detectionSnap['Num-Vehicle'] }}
                            </div>
                          </v-col>
                          <v-col cols="10">
                            <h6 class="overline">Object Types</h6>
                            <h5 class="display-1 font-weight-bold d-inline text--primary">
                              Persons: <span :class="{ 'red--text': detectionSnap['Number-Of-People'] > 2 }">{{
                                detectionSnap['Number-Of-People'] }}</span>
                              <!-- Persons: 3, -->
                            </h5>
                            <h5 class="display-1 font-weight-bold d-inline text--primary">
                              , Vehicles: <span>{{ detectionSnap['Num-Vehicle'] }} </span>
                            </h5>
                            <h5 class="display-1 font-weight-bold d-inline text--primary">
                              , Weapons: 0
                            </h5>
                            <h5 class="display-1 font-weight-bold d-inline text--primary">
                              , Drones: 0
                            </h5>
                            <!-- <h5 class="display-1 font-weight-bold d-inline text--primary">
                              Drones: 1,
                            </h5>
                            <h5 class="display-1 font-weight-bold d-inline text--primary">
                              Guns: 0
                            </h5> -->
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="12">
                <v-card class="ma-3 pt-4" outlined>
                  <v-card-text>
                    <!-- <span class="overline">From 20.10.24 10:00 hrs</span> -->
                    <h4 class="title d-flex align-center justify-center mb-4 primary--text pb-3 px-3">

                      <v-btn-toggle v-model="currentDetectionListTab" tile group>
                        <v-btn :value="0">
                          <v-icon color="primary" left small>mdi-alarm-light</v-icon>
                          Incidents ({{ captions.length }})
                        </v-btn>

                        <v-btn :value="1">
                          Detection Logs ({{ detectionsLog.length }})
                        </v-btn>

                      </v-btn-toggle>
                      <v-spacer></v-spacer>
                      <!-- <span>Incidents (19*)</span> -->
                      <div style="width: 250px;">
                        <!-- <router-link to="/records">View Detection Records </router-link> -->
                        <v-btn to="/records" target="_blank">View Detection Records</v-btn>
                        <!-- <v-select hide-details label="Period" value="Today" outlined
                          :items="['Today', 'Last 48 Hours', 'Last 7 Days', 'Custom']"></v-select> -->
                      </div>
                    </h4>
                    <!-- <div v-if="captionLoading" class="d-flex justify-center pl-5">
                      <em class="body-2">Generating new scene description...</em> -->
                    <!-- <v-progress-circular :width="4" color="red" indeterminate></v-progress-circular> -->
                    <!-- </div> -->
                    <!-- <p v-show="captions.length == 0">Detection: Loading... </p> -->
                    <ul class="scrollable-list">
                      <v-timeline v-if="currentDetectionListTab == 0">

                        <v-timeline-item align="end" v-if="captionLoading" color="primary" small>
                          <template v-slot:opposite>
                            <!-- <span :class="`headline font-weight-bold ${year.color}--text`" v-text="year.year"></span> -->
                            <v-card>
                              <div class="d-flex">
                                <v-skeleton-loader type="chip"></v-skeleton-loader>
                                <v-skeleton-loader class="ml-3" type="chip"></v-skeleton-loader>
                              </div>
                              <v-skeleton-loader class="mt-3" height="150px" type="card"></v-skeleton-loader>
                            </v-card>
                          </template>
                          <div class="py-4">
                            <v-row>
                              <v-col cols="12">
                                <v-skeleton-loader class="mt-3" height="220px"
                                  type="article, actions"></v-skeleton-loader>
                              </v-col>
                            </v-row>
                          </div>
                        </v-timeline-item>

                        <v-timeline-item v-for="(caption, i) in captions" :key="i" color="primary" small>
                          <template v-slot:opposite>
                            <!-- <span :class="`headline font-weight-bold ${year.color}--text`" v-text="year.year"></span> -->
                            <v-card class="">
                              <!-- <v-img height="200px" :src="`http://127.0.0.1:9001/${caption.image_url}`"> -->
                              <v-tabs v-model="selectedCapImgTab[i]" color="primary">
                                <v-tab>Raw</v-tab>
                                <v-tab>Annotated</v-tab>
                              </v-tabs>
                              <v-tabs-items v-model="selectedCapImgTab[i]">
                                <v-tab-item>
                                  <v-img class="mt-3" height="220px"
                                    :src="`http://127.0.0.1:9001/${caption.image_url}`">
                                    <div class="absolute right ma-2">
                                      <v-btn icon @click="currentCaptionImg = caption.image_url">
                                        <v-icon large color="primary">mdi-fullscreen</v-icon>
                                      </v-btn>
                                    </div>
                                  </v-img>
                                </v-tab-item>
                                <v-tab-item>
                                  <v-img class="mt-3" height="220px"
                                    :src="`http://127.0.0.1:9001/${caption.image_url}`">
                                    <div class="absolute right ma-2">
                                      <v-btn icon @click="imageDialogOpen = true">
                                        <v-icon large color="primary">mdi-fullscreen</v-icon>
                                      </v-btn>
                                    </div>
                                  </v-img>
                                </v-tab-item>
                              </v-tabs-items>
                              <!-- {{ caption.image_url }} -->
                            </v-card>
                          </template>
                          <div class="py-10">
                            <v-row>
                              <v-col cols="12">
                                <div class="d-flex">
                                  <!-- <v-chip class="white--text ml-0 mb-3" color="red" label small>
                                    Intrusion Event
                                  </v-chip> -->
                                  <v-chip class="mr-2" dark label small>
                                    {{ currentTime() }} HRS
                                  </v-chip>
                                  <v-chip dark label small>
                                    INTRUSION
                                  </v-chip>
                                  <v-spacer></v-spacer>
                                  <v-btn icon>
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                  </v-btn>
                                </div>
                                <h3 class="title white--text body-1 text-truncate">
                                  {{ caption.text }}
                                  <!-- Person going towards the other part of the valley -->
                                </h3>
                                <!-- <div>21:25 IST</div> -->
                              </v-col>
                              <div class="col-12">
                                <strong>Counts:</strong> Person <strong>{{ caption.num_people }}</strong>, Vehicles
                                <strong>({{ caption.num_vehicle }})</strong>
                              </div>
                              <div cols="12">
                                <!-- <v-btn color="primary" outlined small @click="bottomsheetOpen = true" class="ml-3 mt-2">
                                  <v-icon small left>mdi-play</v-icon>
                                  PLAY CLIP
                                </v-btn> -->
                                <!-- <video src=""></video> -->
                                <v-btn color="primary" small @click="getFullEventDetails(caption.event_id)"
                                  class="ml-3 mt-2">
                                  <v-icon left>mdi-play</v-icon>
                                  FULL DETAILS
                                </v-btn>
                                <!-- <v-btn color="primary" text small @click="bottomsheetOpen = true" class="ml-3 mt-2">
                                  <v-icon small left>mdi-open-in-new</v-icon>
                                  MORE INFO
                                </v-btn> -->
                              </div>
                            </v-row>
                          </div>
                        </v-timeline-item>
                      </v-timeline>
                      <div v-else>
                        <!-- <li v-for="(entry, i) in detectionsLog" :key="i">{{ entry }}</li> -->
                        <v-list subheader two-line>

                          <v-list-item color="red" v-for="(entry, i) in detectionsLog" :key="i">
                            <v-list-item-avatar>
                              <v-icon class="primary">
                                mdi-picture-in-picture-top-right
                              </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title>
                                Persons: <strong>{{ entry['Number-Of-People'] }}</strong>,
                                <!-- Vehicles: <strong>{{ caption["Num-Vehicle"] }}</strong> -->
                              </v-list-item-title>
                              <v-list-item-subtitle v-text="entry.time"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-btn v-if="entry['Number-Of-People'] > 2" icon>
                                <v-icon color="red">mdi-alert-circle</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </div>
                    </ul>
                    <!-- <h5 class="display-1 font-weight-bold d-inline text--primary">
                        02
                      </h5> <span>From 10:00 - ~</span>
                      <div class="mt-2 body-2">Last event at 09:05 <v-btn class="inline-block ml-3" small outlined
                          color="primary">CHECK</v-btn> </div> -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>

      </v-row>
    </v-container>


    <!-- Alerts and Dialogs -->

    <v-dialog v-model="imageDialogOpen" height="1024" width="1024">
      <v-card>
        <v-img :src="`http://127.0.0.1:9001/${currentCaptionImg}`"></v-img>
      </v-card>
    </v-dialog>

    <v-bottom-sheet :overlay-opacity="0.9" v-model="bottomsheetOpen">
      <v-sheet class="px-5">
        <v-divider></v-divider>
        <!-- <EventDetailsViewer :key="edv_key" :event-id="currentEventId" @close="onBottomSheetClose" />         -->
        <EventDetailsViewer :event-id="currentEventId" :thumb-caption="currentEventCaptionText"
          :detection-objects="detectionObjects" @close="onBottomSheetClose" />
      </v-sheet>
    </v-bottom-sheet>


  </div>
</template>

<script>
import Graph from './../components/Graph.vue'
import { format } from 'fecha'
import EventDetailsViewer from './../components/EventDetailsViewer.vue'

export default {
  data: () => ({
    toggle_one: 0,
    // imageDialogOpen: false,
    streamUrl: "",
    metaData: 'Loading...',
    captionLoading: false,
    edv_key: 1,
    fetchMetadataInterval: null,
    // showAlert: false,
    currentCaptionImg: null,
    bottomsheetOpen: false,
    currentEventId: "",
    currentDetectionListTab: 0,
    selectedCapImgTab: [0, 0, 0],

    captions: [],
    detectionsLog: [],
    detectionSnap: { 'Number-Of-People': 0, 'Num-Vehicle': 0 },

    // captions: [{ "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }],
    // detectionsLog: [{ "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 0 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 1 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 1 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 1 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 1 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 11 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 13 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 13 }, { "time": "09:44 hrs", "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 11 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 13 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 8 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 10 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 11 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 12 }, { "time": "09:44 hrs", "Caption": { "event_id": "9c964a5b-28f7-4d57-ab4c-8a9ad6300976", "image_url": "images\\9c964a5b-28f7-4d57-ab4c-8a9ad6300976.jpg", "is_last_frame": false, "num_people": 9, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 4000 }, "Num-Vehicle": 0, "Number-Of-People": 11 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 10 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 10 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 10 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 12 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 12 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 14 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 12 }, { "time": "09:44 hrs", "Caption": { "event_id": "b019050e-9aca-4b4a-9081-7c366a283357", "image_url": "images\\b019050e-9aca-4b4a-9081-7c366a283357.jpg", "is_last_frame": false, "num_people": 10, "num_vehicle": 0, "text": "a group of people standing around a building", "timestamp": 0 }, "Num-Vehicle": 0, "Number-Of-People": 10 }, { "time": "09:44 hrs", "Caption": {}, "Num-Vehicle": 0, "Number-Of-People": 9 }],
    // detectionSnap: { "Caption": { "event_id": "46e8f7f4-3035-48ec-8d8d-a2f8349b01ac", "image_url": "images\\46e8f7f4-3035-48ec-8d8d-a2f8349b01ac.jpg", "is_last_frame": false, "num_people": 8, "num_vehicle": 0, "text": "a group of people standing around a small village", "timestamp": 8000 }, "Num-Vehicle": 0, "Number-Of-People": 0 }
  }),
  components: {
    Graph,
    EventDetailsViewer
  },
  computed: {
    waitForCaptioning() {
      return this.detectionSnap['Number-Of-People'] > 2
    },
    currentEventDetails() {
      return this.captions.find(item => item.event_id == this.currentEventId)
    },
    currentEventCaptionText() {
      return !!this.currentEventDetails ? this.currentEventDetails.text : ""
    },
    detectionObjects() {
      let snap = this.currentEventDetails
      return !!snap ? { persons: snap.num_people, vehicles: snap.num_vehicle, guns: 0, drones: 0 } : {
        persons: 0, vehicles: 0, guns: 0, drones: 0
      }
    },
    imageDialogOpen: {
      get() {
        return !!this.currentCaptionImg;
      },
      set(val) {
        this.currentCaptionImg = !!val;
      }
    }
  },
  methods: {
    test() {
      // console.log("Image load")
    },
    retest() {
      // console.log("image error")
    },
    getFullEventDetails(eventId) {
      this.bottomsheetOpen = true
      this.currentEventId = eventId
    },
    fetchStream() {
      this.streamUrl = 'http://127.0.0.1:9001/stream';
    },
    currentTime() {
      return format(new Date, 'shortTime') + ' hrs'
    },
    onBottomSheetClose() {
      this.bottomsheetOpen = false
      // this.currentEventId = ""
      // this.edv_key *= -1
      // console.log(this.edv_key)
    },
    async fetchMetadata() {
      try {
        const response = await fetch('http://127.0.0.1:9001/metadata')

        const data = await response.json();

        if (data.done) {
          console.log("stream ended")
          clearInterval(this.fetchMetadataInterval)
          return
        }

        this.detectionSnap = data
        this.detectionsLog.unshift({ time: this.currentTime(), ...data })

        // metadataTag.textContent = `Number of people detected: ${data['Number-Of-People']}`;
        if (!!data['Caption'].text) {
          if (!this.captions.find(el => Math.floor(el.timestamp) == Math.floor(data['Caption'].timestamp))) {
            this.captions.unshift(data['Caption'])
            this.captionLoading = false

            //this.showAlert = true
            this.playAlertSound()

            // setTimeout(() => {
            //   this.showAlert = false
            // }, 1000)

            console.log(data['Caption'])
          }
        }

      } catch (error) {
        console.error('Error fetching metadata:', error)
      }
    },

    playAlertSound() {
      console.log("playing audio")
      // const audio = new Audio(require('@/assets/alert_sound.wav`')); // Path to your WAV file
      // console.log(audio)
      // audio.play();
    },
  },

  mounted() {
    this.fetchStream();
    this.fetchMetadataInterval = setInterval(this.fetchMetadata, 1000)
  },
  watch: {
    waitForCaptioning(val) {
      if (val) {
        this.captionLoading = true
        // this.showAlert = true
        /*        setTimeout(() => {
                  this.showAlert = false
                }, 2000)        */
      }
    }
  }
}
</script>


<style>
.scrollable-list {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>